<template>
  <div id="course-create-details-tab" @keyup.ctrl.enter="simulation_legacy_update_data">
    <div class="vx-col w-full">
      <div class="mb-base">
        <vs-input class="mb-10 w-1/5" label-placeholder="Simulation Type" disabled="true" value="Legacy"/>
        <vs-input class="mb-10 w-1/5" label-placeholder="Content File" v-model="dataLocal.content_file"/>
        <vs-input class="mb-10 w-1/5" label-placeholder="Total Score" v-model="dataLocal.total_score"/>
      </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button color="success" type="filled" class="mb-2 mr-2"
                       @click="simulation_legacy_update_data ">Update Simulation Properties
            </vs-button>
            <vs-button color="warning" type="border" class="mb-2 ml-2"
                       @click="reset_data">Reset
            </vs-button>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'


export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data))
    }
  },
  components: {
    vSelect

  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    simulation_legacy_update_data () {
      this.$emit('simulation_legacy_update_data', this.dataLocal)
    },
    reset_data () {
      this.dataLocal = JSON.parse(JSON.stringify(this.data))
    }
  }
}
</script>

<style scoped>

</style>
